import { Typography } from 'antd';

const { Text, Title } = Typography;

export function Dashboard({ menu }) {
  return (
    <div className="admin-menu-route-body">
      <Title level={4}>{menu.menu_name}</Title>
      <Text type="secondary">Dashboard module loaded from menu configuration.</Text>
    </div>
  );
}

export function Jobs({ menu }) {
  return (
    <div className="admin-menu-route-body">
      <Title level={4}>{menu.menu_name}</Title>
      <Text type="secondary">Jobs module loaded from menu configuration.</Text>
    </div>
  );
}

export function Candidate({ menu }) {
  return (
    <div className="admin-menu-route-body">
      <Title level={4}>{menu.menu_name}</Title>
      <Text type="secondary">Candidates module loaded from menu configuration.</Text>
    </div>
  );
}